import { render, staticRenderFns } from "./videoIcon.vue?vue&type=template&id=57ca2c5d&"
import script from "./videoIcon.vue?vue&type=script&lang=js&"
export * from "./videoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports